import type { ProjectId } from 'owa-timestream-types';
import getProject from './getProject';

export default function isProjectPreview(projectId: ProjectId): boolean {
    return !!getProject(projectId)?.isPreview;
}
